module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAByBAMAAAASQsRjAAAAKlBMVEVHcExR08Njzs5Q1MNQ0sJV48ZQ08NR08NQ0sJT1sFQ08VQ0cHJ8++C39Q+mY08AAAADHRSTlMA/AVvswnDTOolI4wDxrjEAAAAyUlEQVRIx2NgYAg3LmXAA5hbdnsY4JF3m8DAmYJHexKX8QI13AZETDC8K8zZilO+hEvmzMEF7jjlrZnvnDlrsJlseULmE3IfIf8RCh+C4csQLog3fhgYBBUYBjUg5L5R94+6f9T9o+4fdf+o+0fdP+r+UfePup+BgbXYPACfvIX3lmY80iyZDAzTHHC7z0xhsRVTMk551k5m2YsGM3C6gN1h4ZkzUiwFYA6jEAYS3mB75sxlbgOi5AmZz0C6+5D9Ryh8yApfaPwAAGgFQhBfKtmUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-line-2.png
// module id = 442
// module chunks = 2